const KEY = (lang) => `flaw_taxonomy_${lang || 'en'}`;

export function saveFlawTaxonomy(lang, categories) {
  localStorage.setItem(KEY(lang), JSON.stringify({
    ts: Date.now(),
    categories: categories || []
  }));
}

export function loadFlawTaxonomy(lang) {
  try {
    const raw = localStorage.getItem(KEY(lang));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed?.categories)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearFlawTaxonomy(lang) {
  localStorage.removeItem(KEY(lang));
}
